let gates = localStorage.getItem('gates') || {}
if (typeof gates === 'string') gates = JSON.parse(gates)
let secret = process.env.MIX_HASH_SECRET || ''
import CryptoJS from 'crypto-js'
import {DateTime} from 'luxon'

export default function (el, binding) {
    el.classList.add('d-none')

    let now = DateTime.now().toISOTime()
    let user = document.querySelector('html').getAttribute('data-user')
    let ability = binding.value.ability || binding.value
    let args = binding.value.args || {}
    let hash = CryptoJS.MD5(JSON.stringify({user, ability, args})).toString()

    const show = () => el.classList.remove('d-none')
    const hide = () => {
        if (binding.arg === 'disable') {
            el.setAttribute('disabled', true)
            el.classList.add('disabled')
            el.classList.remove('d-none')
        }
        else el.remove()
    }

    const store = (gates) => localStorage.setItem('gates', JSON.stringify(gates))
    const encrypt = (object) => CryptoJS.AES.encrypt(JSON.stringify(object), secret).toString()
    const decrypt = (encrypted) => JSON.parse(CryptoJS.AES.decrypt(encrypted, secret).toString(CryptoJS.enc.Utf8))

    // check if the gate result is cached
    if (Object.keys(gates).includes(hash)) {
        let cached = decrypt(gates[hash])
        if (DateTime.now().diff(DateTime.fromISO(cached['now']), 'minutes').minutes > 10) delete gates[hash]
        else if (cached['allowed']) return show()
    }

    window.axios.post('/api/authorize', { ability, arguments: args })
        .then((response) => {
            show()
            gates[hash] = encrypt({
                allowed: true,
                now,
            })
        })
        .catch(() => {
            hide()
            gates[hash] = encrypt({
                allowed: false,
                now,
            })
        })
        .finally(() => store(gates))
}
